import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex justify-content-between align-items-center" }

import { onMounted, ref } from 'vue'
import { Alarm, AlarmClient, AreaOfInterest, DoBChart } from '@/server/MakeSenseApp-backend'
import DoBChartComponent from '../DoBChart.vue'
import { useProjectStore } from '@/stores/ProjectStore'
import { requiredInject } from '@/utilities/requiredInject'
import DoBSwitch from '@/components/charts/switches/DoBSwitch.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'AlarmDoBChart',
  props: {
  alarm: Alarm
},
  setup(__props) {

const props = __props

var showDelta = ref<boolean>(false)

function updateShowDelta(value: boolean) {
  showDelta.value = value
}

const chartData = ref<DoBChart | undefined>(undefined)
const isLoading = ref<boolean>(false)
const areaOfInterest = ref<AreaOfInterest | undefined>(undefined)
let store = useProjectStore()

onMounted(() => {
  const alarmClient = requiredInject<AlarmClient>('AlarmClient')

  if (props.alarm === undefined || props.alarm.id === undefined) {
    console.error('Alarm ID is undefined')
    return
  }

  isLoading.value = true

  alarmClient.doBForAlarm(store.projectId, props.alarm.id).then((data) => {
    areaOfInterest.value = data.areaOfInterest
    chartData.value = data as DoBChart
    isLoading.value = false
  })
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[1] || (_cache[1] = _createElementVNode("h5", null, "Depth of Burial (DoB) Survey Result", -1)),
      _createVNode(DoBSwitch, {
        onShowDelta: _cache[0] || (_cache[0] = (newValue) => updateShowDelta(newValue))
      })
    ]),
    _createVNode(DoBChartComponent, {
      showDelta: _unref(showDelta),
      data: chartData.value,
      "area-of-interest": areaOfInterest.value,
      "is-loading": isLoading.value,
      "show-legend": true
    }, null, 8, ["showDelta", "data", "area-of-interest", "is-loading"])
  ]))
}
}

})